// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.AdminOrders_refunded__g5OoQ {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 5px 1rem;
  font-size: 1rem;
  border-radius: 0.5rem;
  background-color: var(--color-error);
  color: var(--color-white);
  width: 9rem;
}

.AdminOrders_processing__eCQ7x {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 5px 1rem;
  font-size: 1rem;
  border-radius: 0.5rem;
  background-color: var(--color-yellow);
  color: var(--color-dark);
  width: 9rem;
}

.AdminOrders_void__O5twq {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 5px 1rem;
  font-size: 1rem;
  border-radius: 0.5rem;
  background-color: var(--color-dark);
  color: var(--color-white);
  width: 9rem;
}

.AdminOrders_shipped__qJCWj {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 5px 1rem;
  font-size: 1rem;
  border-radius: 0.5rem;
  background-color: var(--color-primary);
  color: var(--color-white);
  width: 9rem;
}

.AdminOrders_delivered__vy8CF {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 5px 1rem;
  font-size: 1rem;
  border-radius: 0.5rem;
  background-color: var(--color-green);
  color: var(--color-white);
  width: 9rem;
}

.AdminOrders_orders__jBF2F {
  display: flex;
  flex-direction: column;
  gap: 2rem;
  padding: 0 2rem 5rem;
}
.AdminOrders_orders__top__pP2yQ {
  display: flex;
  gap: 1.2rem;
  justify-content: space-between;
  align-items: center;
  margin-top: 2rem;
}

.AdminOrders_view__3T\\+KO {
  position: relative;
}
.AdminOrders_view_menu__kqNn- {
  color: var(--color-primary);
  cursor: pointer;
  font-size: 3rem;
  position: absolute;
  left: 20.5rem;
  top: 6rem;
}
.AdminOrders_view_customerMenu__g6V85 {
  right: -20rem;
  top: 6rem;
}
.AdminOrders_view_content__F5yku {
  width: 35rem;
  margin-top: 3rem;
}

.AdminOrders_sum__-JbbE {
  display: flex;
  justify-content: space-between;
  width: 100%;
  padding: 8px 0;
}

.AdminOrders_line__KsoyS {
  border: 0.1px solid var(--color-grey);
  margin: 2rem 0;
}`, "",{"version":3,"sources":["webpack://./src/assets/styles/Admin/AdminOrders.module.scss"],"names":[],"mappings":"AAAA;EACC,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,iBAAA;EACA,eAAA;EACA,qBAAA;EACA,oCAAA;EACA,yBAAA;EACA,WAAA;AACD;;AAEA;EACC,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,iBAAA;EACA,eAAA;EACA,qBAAA;EACA,qCAAA;EACA,wBAAA;EACA,WAAA;AACD;;AAEA;EACC,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,iBAAA;EACA,eAAA;EACA,qBAAA;EACA,mCAAA;EACA,yBAAA;EACA,WAAA;AACD;;AAEA;EACC,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,iBAAA;EACA,eAAA;EACA,qBAAA;EACA,sCAAA;EACA,yBAAA;EACA,WAAA;AACD;;AAEA;EACC,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,iBAAA;EACA,eAAA;EACA,qBAAA;EACA,oCAAA;EACA,yBAAA;EACA,WAAA;AACD;;AAEA;EACC,aAAA;EACA,sBAAA;EACA,SAAA;EACA,oBAAA;AACD;AACC;EACC,aAAA;EACA,WAAA;EACA,8BAAA;EACA,mBAAA;EACA,gBAAA;AACF;;AAGA;EACC,kBAAA;AAAD;AAEC;EACC,2BAAA;EACA,eAAA;EACA,eAAA;EACA,kBAAA;EACA,aAAA;EACA,SAAA;AAAF;AAGC;EACC,aAAA;EACA,SAAA;AADF;AAIC;EACC,YAAA;EACA,gBAAA;AAFF;;AAMA;EACC,aAAA;EACA,8BAAA;EACA,WAAA;EACA,cAAA;AAHD;;AAMA;EACC,qCAAA;EACA,cAAA;AAHD","sourcesContent":[".refunded {\n\tdisplay: flex;\n\tjustify-content: center;\n\talign-items: center;\n\tpadding: 5px 1rem;\n\tfont-size: 1rem;\n\tborder-radius: 0.5rem;\n\tbackground-color: var(--color-error);\n\tcolor: var(--color-white);\n\twidth: 9rem;\n}\n\n.processing {\n\tdisplay: flex;\n\tjustify-content: center;\n\talign-items: center;\n\tpadding: 5px 1rem;\n\tfont-size: 1rem;\n\tborder-radius: 0.5rem;\n\tbackground-color: var(--color-yellow);\n\tcolor: var(--color-dark);\n\twidth: 9rem;\n}\n\n.void {\n\tdisplay: flex;\n\tjustify-content: center;\n\talign-items: center;\n\tpadding: 5px 1rem;\n\tfont-size: 1rem;\n\tborder-radius: 0.5rem;\n\tbackground-color: var(--color-dark);\n\tcolor: var(--color-white);\n\twidth: 9rem;\n}\n\n.shipped {\n\tdisplay: flex;\n\tjustify-content: center;\n\talign-items: center;\n\tpadding: 5px 1rem;\n\tfont-size: 1rem;\n\tborder-radius: 0.5rem;\n\tbackground-color: var(--color-primary);\n\tcolor: var(--color-white);\n\twidth: 9rem;\n}\n\n.delivered {\n\tdisplay: flex;\n\tjustify-content: center;\n\talign-items: center;\n\tpadding: 5px 1rem;\n\tfont-size: 1rem;\n\tborder-radius: 0.5rem;\n\tbackground-color: var(--color-green);\n\tcolor: var(--color-white);\n\twidth: 9rem;\n}\n\n.orders {\n\tdisplay: flex;\n\tflex-direction: column;\n\tgap: 2rem;\n\tpadding: 0 2rem 5rem;\n\n\t&__top {\n\t\tdisplay: flex;\n\t\tgap: 1.2rem;\n\t\tjustify-content: space-between;\n\t\talign-items: center;\n\t\tmargin-top: 2rem;\n\t}\n}\n\n.view {\n\tposition: relative;\n\n\t&_menu {\n\t\tcolor: var(--color-primary);\n\t\tcursor: pointer;\n\t\tfont-size: 3rem;\n\t\tposition: absolute;\n\t\tleft: 20.5rem;\n\t\ttop: 6rem;\n\t}\n\n\t&_customerMenu {\n\t\tright: -20rem;\n\t\ttop: 6rem;\n\t}\n\n\t&_content {\n\t\twidth: 35rem;\n\t\tmargin-top: 3rem;\n\t}\n}\n\n.sum {\n\tdisplay: flex;\n\tjustify-content: space-between;\n\twidth: 100%;\n\tpadding: 8px 0;\n}\n\n.line {\n\tborder: 0.1px solid var(--color-grey);\n\tmargin: 2rem 0;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"refunded": `AdminOrders_refunded__g5OoQ`,
	"processing": `AdminOrders_processing__eCQ7x`,
	"void": `AdminOrders_void__O5twq`,
	"shipped": `AdminOrders_shipped__qJCWj`,
	"delivered": `AdminOrders_delivered__vy8CF`,
	"orders": `AdminOrders_orders__jBF2F`,
	"orders__top": `AdminOrders_orders__top__pP2yQ`,
	"view": `AdminOrders_view__3T+KO`,
	"view_menu": `AdminOrders_view_menu__kqNn-`,
	"view_customerMenu": `AdminOrders_view_customerMenu__g6V85`,
	"view_content": `AdminOrders_view_content__F5yku`,
	"sum": `AdminOrders_sum__-JbbE`,
	"line": `AdminOrders_line__KsoyS`
};
export default ___CSS_LOADER_EXPORT___;
